import React from "react";
import {Outlet} from "react-router-dom";
import {Container, ThemeProvider} from "react-bootstrap";

export function EmptyLayout({children}) {

    return (
        <ThemeProvider>
            <Container>
                <Outlet/>
            </Container>
        </ThemeProvider>
    );
}
